import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import NavTop2Component from "../../components/user/NavTop2Component";
import LandingNavbar from "../../components/user/LandingNavbar";
import NumberIncrementComponent from "../../components/user/NumberIncrementComponent";
import LandingWhyManscapeComponent from "../../components/user/LandingWhyManscapeComponent";
import LandingVideoComponent from "../../components/user/LandingVideoComponent";
import LandingPageWhyUs from "../../components/user/LandingPageWhyUs";
import LandingTestimonialComponent from "../../components/user/LandingTestimonialComponent";
import FaqComponent from "../../components/user/FaqComponent";
import LandingLocationComponent from "../../components/user/LandingLocationComponent";
import LandingFooterComponent from "../../components/user/LandingFooterComponent";
import ContactButtons from "../../components/user/ContactButtons";
import LandingPackageComponent from "../../components/user/LandingPackageComponent";
import LandingPriceNcrPagePriceComponent from "../../components/user/LandingPriceNcrPagePriceComponent";
import LandingHeaderNCR from "../../components/user/LandingHeaderNCR";
import PopupForm from "../../components/user/popUp/PopupForm";
import PopupNumber from "../../components/user/popUp/PopupNumber";
import ChooseLocation from "../../components/cart/ChooseLocation";
import CartComponent from "../../components/user/CartComponent";
import VideoLandingPage from "../service/VideoLandingPage";
import NumberIncrementVideoComponent from "../../components/user/NumberIncrementVideoComponent";

const LandingVideoPageNcr = ({ location }) => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);


  const [popupForm, setPopupForm] = useState(true)
  const [popupNumber, setPopupNumber] = useState(false)


  
  
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  
      const timeoutRef = useRef(null);
    
      // Function to show alert
      const showAlert = () => {
        setPopupNumber(true);
      };
    
      
      const resetTimer = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(showAlert, 20000);
      };
    
      useEffect(() => {
        const events = ['click', 'scroll', 'mousemove', 'keydown'];
    
        events.forEach(event =>
          window.addEventListener(event, resetTimer)
        );
    
        // Start the initial timer
        resetTimer();
    
        // Cleanup on unmount
        return () => {
          events.forEach(event =>
            window.removeEventListener(event, resetTimer)
          );
          clearTimeout(timeoutRef.current);
        };
      }, []);
    
    
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

      const submittedRef = useRef(null);
    
      const handleScroll = (e) => {
        if (submittedRef.current) {
          submittedRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      };
    
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  

  return (
    <div>
      <Helmet>
        <title>Male beauty and waxing service at home in {location}</title>

        <meta
          name="description"
          content={`
          Book Glazma online male beauty and waxing service at home in ${location}. Get best men's grooming and waxing service by professional groomers.
          `}
        />

        <meta
          name="keywords"
          content={`
          Men's grooming home service
          `}
        />
      </Helmet>

{/* {
popupForm?
      <PopupForm handleScroll={handleScroll} open={setPopupForm}/>
      :""
} */}
      {
popupNumber?
      <PopupNumber open={setPopupNumber}/>
      :""
      } 
      
      {/* <div onClick={handleSubmit}>handleSubmit</div> */}

      
      

      <div className="landing-page landing-page-ncr">
        <div id="book-now" className="landing-web-target"></div>
        <div className="landing-page-navbar">
          <NavTop2Component />
          <LandingNavbar />
        </div>
        <LandingHeaderNCR location={location} />

                {/* <NumberIncrementComponent /> */}
                <NumberIncrementVideoComponent/>

            <VideoLandingPage/>
        

        <div>
          <LandingPriceNcrPagePriceComponent submittedRef={submittedRef} location={location} />
        </div>

        {/* <div>
          <LandingPackageComponent />
        </div> */}

        <LandingWhyManscapeComponent />
        {/* <NumberIncrementComponent /> */}
        
        <LandingVideoComponent />

        <div>
          <LandingPageWhyUs />
        </div>




        <div>
          <LandingTestimonialComponent />
        </div>

        <div>
          <FaqComponent />
        </div>

        <LandingLocationComponent />

        <LandingFooterComponent />
      </div>
      {/* <ContactButtons /> */}
    </div>
  );
};

export default LandingVideoPageNcr;

// export default LandingVideoPageNcr